/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */
/* eslint-disable sort-keys */
/** The rendering size of a component. */
export var Size = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
};
//# sourceMappingURL=size.js.map